module.exports = __webpack_public_path__ + "static/media/i8-3-mike.c6062de3.png";